import { api } from '../../lib/apiClient';
import { uploadDirect } from '../../lib/directUpload';
import { useAuthStore } from '../../store/authStore';

const ws = () => {
  const id = useAuthStore.getState().workspaceId;
  if (!id) throw new Error('No active workspace selected');
  return `/workspaces/${id}/forms`;
};

export const formKeys = { all: ['forms'], detail: (id) => ['form', id], responses: (id, page) => ['form-responses', id, page], public: (id) => ['public-form', id] };
export const listForms = async (params) => (await api.get(ws(), { params })).data;
export const getForm = async (id) => (await api.get(`${ws()}/${id}`)).data;
export const createForm = async (body) => (await api.post(ws(), body)).data;
export const updateForm = async ({ id, body }) => (await api.put(`${ws()}/${id}`, body)).data;
export const deleteForm = (id) => api.delete(`${ws()}/${id}`);
export const listResponses = async (id, params) => (await api.get(`${ws()}/${id}/submissions`, { params })).data;
export const previewForm = async (id) => (await api.get(`${ws()}/${id}/preview`)).data;
export const getPublicForm = async (id) => (await api.get(`/public/forms/${id}`, { skipAuth: true })).data;

/**
 * What the public form page actually calls. A respondent gets the public endpoint and nothing else.
 * An owner who opens their own draft's link falls through to the preview endpoint, which is guarded
 * by the same permission as managing the form. If that also fails, the public error is what shows,
 * so a stranger never learns whether the form exists.
 */
export async function getPublicFormOrOwnerPreview(id) {
  try {
    return await getPublicForm(id);
  } catch (publicError) {
    const { accessToken, workspaceId } = useAuthStore.getState();
    if (!accessToken || !workspaceId) throw publicError;
    try {
      return await previewForm(id);
    } catch {
      throw publicError;
    }
  }
}
export const verifyFormPin = async (id, pincode) => (await api.post(`/public/forms/${id}/verify`, { pincode }, { skipAuth: true })).data;
export const submitPublicForm = async (id, body) => (await api.post(`/public/forms/${id}/submissions`, body, { skipAuth: true })).data;

/** Upload a respondent's file browser → storage; resolves to the token that answers the field on submit. */
export async function uploadPublicFormFile(id, { file, fieldId, pincode, onProgress, signal }) {
  let uploadToken;
  await uploadDirect({
    file, onProgress, signal, skipAuth: true,
    begin: async () => {
      const { data } = await api.post(`/public/forms/${id}/uploads`, { fieldId, name: file.name, size: file.size, mimeType: file.type || undefined, ...(pincode ? { pincode } : {}) }, { skipAuth: true });
      uploadToken = data.uploadToken;
      return data;
    },
  });
  return uploadToken;
}
